import { useContext } from '@/compat';
import { useToast } from '@/helpers/misc/dialog';

const useClipboard = () => {
  const { $i18n, $lang } = useContext();
  const toast = useToast();

  const copy = (value, container = document) => {
    try {
      const tempInput = document.createElement('textarea');
      tempInput.value = value;
      tempInput.setAttribute('readonly', '');
      container.appendChild(tempInput);
      tempInput.select();

      document.execCommand('copy');
      container.removeChild(tempInput);

      toast.success($i18n.t($lang.app.SUCCESSFULLY_COPIED_TO_CLIPBOARD));
    } catch (error) {
      toast.error($i18n.t($lang.app.ERROR));


      console.error(error);
    }
  };

  return {
    copy,
  };
};

export default useClipboard;
